import { type FullAirHandlerUnit } from "@eisox/api/core-api";
import { Typography } from "@eisox/design-system";

import { Inconsistency } from "./inconsistency";

interface DiscrepancyLabelProps {
  label: React.ReactNode;
  property: Paths<FullAirHandlerUnit>;
}

/**
 * A slider/field label carrying the group-inconsistency badge for `property`. Pass it as the `label`
 * of a form `field.Slider` (or the design-system `Slider`) so grouped CTAs surface out-of-sync values.
 */
export const DiscrepancyLabel: React.FC<DiscrepancyLabelProps> = ({ label, property }) => (
  <span className="mr-2.5 gap-2.5 flex flex-nowrap items-center">
    <Typography>{label}</Typography>
    <Inconsistency property={property} />
  </span>
);
